import { idSchema } from "@resume-studio/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const deleteCoverLetterSchema = z.object({
  id: idSchema,
});

export class DeleteCoverLetterDto extends createZodDto(deleteCoverLetterSchema) {}
